import { WhatsAppIcon } from "./WhatsAppIcon";

const ITEMS = [
  "IGI Certified Solitaires", "Engagement & Anniversary Rings", "CVD & HPHT", "Sieve -2 to +15", "Sold Carat-wise", "Melee Parcels for Jewellers",
  "D–F Colour", "FL to I3 Clarity", "Ethical & Conflict-free", "GST Invoice", "Abids · Hyderabad", "Custom Jewellery & Gifts", <><WhatsAppIcon size={22} className="text-[#25D366] mr-2" /> Quotes</>,
];

export const Marquee = () => (
  <div data-testid="marquee" className="relative z-10 border-y border-gold/20 bg-night overflow-hidden py-5">
    <div className="marquee-track flex whitespace-nowrap">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0">
          {ITEMS.map((t, i) => (
            <span key={i} className="flex items-center font-display text-xl sm:text-2xl text-ivory/80 px-8">
              {t}
              <span className="ml-8 inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
